
namespace RioERP.Reports {
    export class OrderPaymentColumns {
        static columnsKey = 'Reports.OrderPayment';
    }
}